import DossierFeedbackRepositoryInterface, {
  AgentFeedbackInterface, ChatCommentCreateInterface, CommentsRequestParametersInterface,
  CreateAgentFeedbackInterface,
  FeedbackCategoryInterface, DossierFeedbackChatCommentInterface,
  FeedbackTypeInterface,
  UpdateAgentFeedbackInterface, DossierFeedbackTicketCommentInterface, TicketCommentCreateInterface,
} from '@/services/Dossier/feedback/interfaces';
import { AxiosInstance } from 'axios';


export default class DossierFeedbackRepository implements DossierFeedbackRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createFeedback(data: CreateAgentFeedbackInterface): Promise<AgentFeedbackInterface> {
    const response = await this.axios.post('/dossier-controller/feedbacks', data);

    return response.data;
  }

  public async getFeedback(feedbackId: number): Promise<AgentFeedbackInterface> {
    const response = await this.axios.get(`/dossier-controller/feedbacks/${feedbackId}`);

    return response.data;
  }

  public async updateFeedback(id: number, data: UpdateAgentFeedbackInterface): Promise<void> {
    await this.axios.patch(`/dossier-controller/feedbacks/${id}`, data);
  }

  public async deleteFeedback(id: number): Promise<void> {
    await this.axios.delete(`/dossier-controller/feedbacks/${id}`);
  }

  public async getFeedbackCategories(): Promise<FeedbackCategoryInterface[]> {
    const response = await this.axios.get('/dossier-controller/feedback-categories');

    return response.data;
  }

  public async getFeedbackTypes(): Promise<FeedbackTypeInterface[]> {
    const response = await this.axios.get('/dossier-controller/feedback-types');

    return response.data;
  }

  public async createChatComment(data: ChatCommentCreateInterface): Promise<void> {
    await this.axios.post('/dossier-controller/chat-comments', data);
  }

  public async createTicketComment(data: TicketCommentCreateInterface): Promise<void> {
    await this.axios.post('/dossier-controller/ticket-comments', data);
  }

  public async getChatComments(
    parameters: CommentsRequestParametersInterface,
  ): Promise<DossierFeedbackChatCommentInterface[]> {
    const paramStr = Object.keys(parameters)
      .filter((key) => !!parameters[key])
      .map((key) => {
        if (typeof parameters[key] === 'object') {
          return (parameters[key] as Array<number | string>).map((val) => `${key}[]=${val}`).join('&');
        }

        return `${key}=${parameters[key]}`;
      }).join('&');

    const response = await this.axios.get(`/dossier-controller/chat-comments?${paramStr}`);

    return response.data;
  }

  public async getTicketComments(
    parameters: CommentsRequestParametersInterface,
  ): Promise<DossierFeedbackTicketCommentInterface[]> {
    const paramStr = Object.keys(parameters)
      .filter((key) => !!parameters[key])
      .map((key) => {
        if (typeof parameters[key] === 'object') {
          return (parameters[key] as Array<number | string>).map((val) => `${key}[]=${val}`).join('&');
        }

        return `${key}=${parameters[key]}`;
      }).join('&');

    const response = await this.axios.get(`/dossier-controller/ticket-comments?${paramStr}`);

    return response.data;
  }
}
